import { useEffect, useState } from "react";
import Button from "../../../components/button";
import CardContainer from "../../../components/card_container";
import Input from "../../../components/input";
import LoadingModal from "../../../components/loading_modal";
import UseFormUser from "./hookForm";

const EditUserPage = () => {
    const {
        isLoadingPut,
        form,
        handleChange,
        handleSubmit,
    } = UseFormUser({
        type: "put",
    });

    return (
        <>
            <CardContainer
                title={"Edit Data"}
                isBack={true}
                children={(
                    <form className="" onSubmit={(e) => handleSubmit(e)}>
                        <div className="form-user">
                            <div className="expanded-y">
                                <Input value={form.name} style={{ width: "100%" }} id="name" onChange={handleChange} label="Name" placeholder="Input name" required={true} />
                                <Input value={form.email} style={{ width: "100%" }} id="email" onChange={handleChange} label="Email" placeholder="Input email" required={true} />
                                <Input value={form.password} type="password" style={{ width: "100%" }} id="password" onChange={handleChange} label="Password" placeholder="Input password" required={false} />
                                <Input value={form.phone_number} style={{ width: "100%" }} id="phone_number" onChange={handleChange} label="Phone Number" placeholder="Input phone number" required={true} />
                                <Input value={form.height} style={{ width: "100%" }} id="height" onChange={handleChange} label="Height (in cm)" placeholder="Input height (in cm)" required={true} />
                                <Input value={form.weight} style={{ width: "100%" }} id="weight" onChange={handleChange} label="Weight (in kg)" placeholder="Input weight (in kg)" required={true} />
                                <Input value={form.age} style={{ width: "100%" }} id="age" onChange={handleChange} label="Age (in years)" placeholder="Input Age (in years)" required={true} />
                            </div>
                            <hr style={{ width: "100%" }} />
                            <div className="footer-form">
                                <Button type="button" className="btn-outline-primary" style={{ marginRight: "8px" }} title="Cancel" onClick={() => window.history.back()} />
                                <Button type="submit" className="btn-primary" title="Save" />
                            </div>
                        </div>
                    </form>
                )}
            />
            <LoadingModal isLoading={isLoadingPut} />
        </>
    );
};

export default EditUserPage;
